import axios from 'axios';

const TRADING_PLATFORM_URL =
  process.env.REACT_APP_TRADING_PLATFORM_URL || 'http://localhost:9000';

const tradingClient = axios.create({
  baseURL: TRADING_PLATFORM_URL,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const getTradingPlatformUrl = () => TRADING_PLATFORM_URL;

function userHeaders(userId, extra = {}) {
  return {
    'X-User-Id': String(userId || '1001'),
    ...extra,
  };
}

export async function tradingApi(userId, path, { method = 'GET', body, headers, params } = {}) {
  try {
    const { data } = await tradingClient.request({
      method,
      url: path,
      data: body,
      params,
      headers: { ...userHeaders(userId), ...headers },
    });
    return data;
  } catch (err) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string') throw new Error(detail);
    if (Array.isArray(detail) && detail[0]?.msg) throw new Error(detail[0].msg);
    throw new Error(err.message || 'Trading platform request failed');
  }
}
